<template>
  <svg
    id="flag-icon-css-de"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 480"
    :height="height"
  >
    <path fill="#fff" d="M0 0h640v480H0z" />
    <path fill="#002f6c" d="M0 174.5h640v131H0z" />
    <path fill="#002f6c" d="M175.5 0h130.9v480h-131z" />
  </svg>
</template>

<script>
export default {
  name: 'FiFlag',
  props: {
    height: {
      type: String,
      default: '20px'
    }
  }
}
</script>
